import script from "./CrmCompanies.vue?vue&type=script&setup=true&lang=js"
export * from "./CrmCompanies.vue?vue&type=script&setup=true&lang=js"

import "./CrmCompanies.vue?vue&type=style&index=0&id=36d8f04c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36d8f04c"]])

export default __exports__